// =====================================================
// 📁 POSCommentSection.tsx
// =====================================================
// Comentario interno de la venta (campo `comments` en SaleEntity). Se
// transmite a Hacienda en la sección opcional "Apéndice" del DTE
// (ApendiceCommentResolver, backend) cuando no está vacío.

import { useSale } from '../../../../hooks/sale/useSale';

const POSCommentSection = () => {
  const { form, updateField } = useSale();

  return (
    <div
      className="
        mt-5

        border-t
        border-slate-100

        pt-5

        dark:border-strokedark
      "
    >
      <div className="mb-3">
        <h3
          className="
            text-sm
            font-semibold
            text-slate-800

            dark:text-white
          "
        >
          Comentario
        </h3>

        <p
          className="
            mt-1
            text-xs
            text-slate-500

            dark:text-slate-400
          "
        >
          Opcional. Se incluye en el DTE (sección Apéndice) y en la
          representación gráfica de la venta.
        </p>
      </div>

      <textarea
        name="comments"
        rows={3}
        value={form.comments ?? ''}
        onChange={(e) => updateField('comments', e.target.value)}
        placeholder="Escribe un comentario para esta venta…"
        className="
          w-full

          resize-none

          rounded-xl

          border
          border-stroke

          bg-white

          px-4
          py-3

          text-sm
          text-black

          outline-none

          transition-all

          placeholder:text-body

          focus:border-primary
          focus:ring-2
          focus:ring-primary/10

          hover:border-primary/30

          dark:border-strokedark
          dark:bg-boxdark
          dark:text-white
          dark:placeholder:text-bodydark
        "
      />
    </div>
  );
};

export default POSCommentSection;
